import React, { useContext } from 'react';
import { observer } from 'mobx-react';
import { Item } from 'react-contexify';
import StackLayout from '../../../../../layouts/stackLayout/StackLayoutComponent';
import Icon from '../../../../icon/IconComponent';
import Text from '../../../../../core/text/TextComponent';
import ContextMenuContext from '../../../dataLayer/contexts/ContextMenuContext';
var ContextMenuItemImplementation = function (_a) {
    var icon = _a.icon, label = _a.label, noTranslation = _a.noTranslation, hidden = _a.hidden, children = _a.children, testId = _a.testId, onPress = _a.onPress;
    var activeContextMenuVariation = useContext(ContextMenuContext);
    if (hidden) {
        return null;
    }
    return (React.createElement(Item, { onClick: onPress }, children ? children : React.createElement(StackLayout, { testId: testId, horizontal: true, padding: true, vCenter: true },
        React.createElement(Icon, { icon: icon, variationKey: activeContextMenuVariation.iconVariation, marginRight: true }),
        React.createElement(Text, { variationKey: activeContextMenuVariation.textVariation, noTranslation: noTranslation }, label))));
};
export default observer(ContextMenuItemImplementation);
//# sourceMappingURL=ContextMenuItemImplementation.js.map